<div class="page-container explorer-container container w-100">
  <app-utility-toolbar
    class="vertical {{ navCollapsed ? 'w-5' : 'w-15' }}"
    [current]="'caseExplorer'"
    [vertical]="true"
    [links]="dashboardLinks"
    (toggleCollapse)="toggleNavCollapse()"
  />
  <div
    class="explorer-content-container ps-3"
    [ngClass]="{ collapsed: navCollapsed }"
  >
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    >
      <button
        matTooltip="Limit {{ downloadLimit }}"
        type="button"
        mat-button
        color="primary"
        class="grid-button header-button"
        matTooltipPosition="above"
        aria-label="Download excel file of grid button with a menu"
        [disabled]="fileLoading"
        [matMenuTriggerFor]="menu"
        ><span class="button-label-with-icon">
          @if (fileLoading) {
            <mat-spinner diameter="20" />
          } @else {
            <mat-icon>cloud_download</mat-icon>
          }
          Download Excel File</span
        >
      </button>
      <mat-menu #menu="matMenu">
        <button type="button" mat-menu-item (click)="dlXlsx()">
          <mat-icon>file_download</mat-icon>
          <span>All Data</span>
        </button>
        <button type="button" mat-menu-item (click)="dlXlsx(true)">
          <mat-icon>filter_alt</mat-icon>
          <span>Filtered Data</span>
        </button>
      </mat-menu>
    </app-rb-grid>
  </div>
</div>
